// src/Context/CartContext.js

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";

const CartContext = createContext();

export const CartProvider = ({
  children,
}) => {

  // LOAD CART
  const [cartItems, setCartItems] =
    useState(() => {

      const storedCart =
        localStorage.getItem(
          "cartItems"
        );

      return storedCart
        ? JSON.parse(storedCart)
        : [];
    });

  // SAVE CART
  useEffect(() => {

    localStorage.setItem(
      "cartItems",
      JSON.stringify(cartItems)
    );

  }, [cartItems]);

  // ADD TO CART
  const handleAddToCart = (
    product
  ) => {

    setCartItems((prev) => {

      // UNIQUE ID
      const uniqueId =
        `${product.id}-${product.price}`;

      // CHECK EXISTING
      const existingItem =
        prev.find(
          (item) =>
            item.uniqueId ===
            uniqueId
        );

      // UPDATE QTY
      if (existingItem) {

        return prev.map((item) =>

          item.uniqueId ===
          uniqueId
            ? {
                ...item,

                qty:
                  Number(
                    item.qty
                  ) + 1,
              }
            : item
        );
      }

      // ADD NEW ITEM
      return [
        ...prev,
        {
          ...product,

          uniqueId,

          qty: Number(
            product.qty || 1
          ),

          price: Number(
            product.price || 0
          ),
        },
      ];
    });
  };

  // REMOVE
  const removeFromCart = (
    uniqueId
  ) => {

    setCartItems((prev) =>

      prev.filter(
        (item) =>
          item.uniqueId !==
          uniqueId
      )
    );
  };

  // UPDATE QTY
  const updateQty = (
    uniqueId,
    type
  ) => {

    setCartItems((prev) =>

      prev.map((item) => {

        if (
          item.uniqueId ===
          uniqueId
        ) {

          let updatedQty =
            Number(item.qty);

          if (type === "inc") {
            updatedQty += 1;
          }

          if (
            type === "dec" &&
            updatedQty > 1
          ) {
            updatedQty -= 1;
          }

          return {
            ...item,
            qty: updatedQty,
          };
        }

        return item;
      })
    );
  };

  // CLEAR CART
  const clearCart = () => {

    setCartItems([]);

    localStorage.removeItem(
      "cartItems"
    );
  };

  // TOTAL ITEMS
  const totalCartItems =
    cartItems.reduce(
      (acc, item) =>
        acc + Number(item.qty),
      0
    );

  // TOTAL PRICE
  const totalPrice =
    cartItems.reduce(
      (acc, item) =>
        acc +
        Number(item.price) *
          Number(item.qty),
      0
    );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        handleAddToCart,
        removeFromCart,
        updateQty,
        clearCart,
        totalCartItems,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () =>
  useContext(CartContext);